<template>
  <v-select
    class='select-box'
    ref='select'
    :value="value"
    :rules="rules"
    @input="v => $emit('input', v)"
    v-bind="$attrs"
  />
</template>

<script>
export default {
  name: 'select-box',
  // v-bind="$attrs" で明示的に渡すため、自動適用による二重適用を防ぐ
  inheritAttrs: false,
  props: {
    value: {
      required: true,
    },
    rules: Array,
  },
  methods: {
    blur() {
      this.$refs.select.blur();
    },
    validate() {
      this.$refs.select.validate();
    },
  },
};
</script>
<style scoped lang="sass">
@import 'vuetify/src/styles/styles.sass'

.v-select
  ::v-deep .v-input__control
    border: 0 !important

  ::v-deep .v-select__slot
    border: 1px solid

    .v-label
      transform: translateY(-24px) scale(.75)

  ::v-deep .v-text-field__details,
  ::v-deep .v-messages
    min-height: 0

  ::v-deep .v-select__selections
    padding: 0 7px
</style>

<style lang="sass">
.option--full-text .v-list-item__title
  white-space: normal
  overflow-wrap: anywhere

  /* Revert to default values */
  overflow: visible
  text-overflow: clip
</style>
